import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Card, CardHeader, CardText, CardTitle } from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import Dialog from 'material-ui/Dialog';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import FullscreenIcon from 'material-ui/svg-icons/navigation/fullscreen';
import { theme } from '../../utils/getTheme';

const CardIcon = styled.div`
  position: absolute;
  top: 12px;
  right: 40px;
  opacity: 0.54;
`;

const IconButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 56px;
`;

class JobDetailCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      jobDetailOpen: false,
    };
  }

  openJobDetails = () => {
    this.setState(() => ({
      jobDetailOpen: true,
    }));
  };

  closeJobDetail = () => {
    this.setState(() => ({
      jobDetailOpen: false,
    }));
  };

  render() {
    const { jobDetailOpen } = this.state;
    const {
      id,
      jobTitle,
      jobDescription,
      ctc,
      employmentType,
      jobLocation,
      removeJob,
    } = this.props;
    return (
      <div>
        <Card style={{ position: 'relative' }}>
          <CardHeader
            title={jobTitle}
            subtitle={`₹${ctc} | ${employmentType} `}
          />
          <CardIcon>
            <IconButton>
              <IconButtonWrapper>
                <FullscreenIcon
                  color={theme.primary1Color}
                  onTouchTap={this.openJobDetails}
                />
                <CloseIcon
                  color={theme.primary1Color}
                  onTouchTap={() => {
                    removeJob(id);
                  }}
                />
              </IconButtonWrapper>
            </IconButton>
          </CardIcon>
        </Card>
        <Dialog
          // title="Job Details"
          modal
          actions={
            <FlatButton label="Ok" primary onTouchTap={this.closeJobDetail} />
          }
          open={jobDetailOpen}
          onRequestClose={this.closeConfirmModal}
          autoScrollBodyContent
        >
          <Card style={{ padding: 0, position: 'relative' }}>
            <CardTitle
              title="Job Details"
              titleColor={theme.alternateTextColor}
              style={{
                backgroundColor: theme.primary1Color,
                position: 'fixed',
                width: '100%',
                top: 0,
                left: 0,
              }}
            />
            <CardHeader
              title={jobTitle}
              subtitle={`₹${ctc} | ${employmentType} `}
            />
            <CardText style={{ paddingTop: 0 }}>
              <b>JobLocation: </b>
              {jobLocation}
              <br /> <br />
              <CardHeader title="Job Description" style={{ paddingLeft: 0 }} />
              {jobDescription
                .split('\n')
                .map((text, i) => <p key={i}>{text}</p>)}
            </CardText>
          </Card>
        </Dialog>
      </div>
    );
  }
}

JobDetailCard.propTypes = {
  jobLocation: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  jobTitle: PropTypes.string.isRequired,
  jobDescription: PropTypes.string.isRequired,
  ctc: PropTypes.string.isRequired,
  employmentType: PropTypes.string.isRequired,
  removeJob: PropTypes.func.isRequired,
};

export default JobDetailCard;



// WEBPACK FOOTER //
// ./src/components/JobDetailCard/JobDetailCard.js